import React, { useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import AddIcon from "@material-ui/icons/Add";
import { Button, Grid, TextField, Tooltip, InputAdornment, makeStyles, useTheme, useMediaQuery } from "@material-ui/core";
import ExportMenu from '../ExportMenu';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		padding: theme.spacing(0.5, 0),
	},
	searchGrid: {
		[theme.breakpoints.down('xs')]: {
			marginBottom: theme.spacing(1),
		},
	},
	searchField: {
		'& .MuiOutlinedInput-root': {
			fontSize: 12,
			[theme.breakpoints.down('xs')]: {
				fontSize: 13,
			},
		},
	},
	actionsGrid: {
		display: 'flex',
		alignItems: 'center',
		[theme.breakpoints.down('xs')]: {
			justifyContent: 'center',
		},
		[theme.breakpoints.up('sm')]: {
			justifyContent: 'flex-end',
		},
	},
	actionsList: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 6,
		margin: 0,
		padding: 0,
		listStyle: 'none',
		[theme.breakpoints.down('xs')]: {
			justifyContent: 'center',
			width: '100%',
		},
		[theme.breakpoints.between('sm', 'md')]: {
			justifyContent: 'flex-end',
		},
		[theme.breakpoints.up('md')]: {
			justifyContent: 'flex-end',
		},
	},
	actionItem: {
		[theme.breakpoints.down('xs')]: {
			flexGrow: 1,
			minWidth: 'calc(50% - 6px)',
			maxWidth: 'calc(50% - 6px)',
			'& button, & > div': {
				width: '100%',
			},
		},
		[theme.breakpoints.between('sm', 'sm')]: {
			flexShrink: 0,
		},
		[theme.breakpoints.up('md')]: {
			flexShrink: 0,
		},
	},
}));

const CamoCTA = ({ searchPlaceholder, defaultSearchValue, onSearch, permissionCheck, addLabel, onAddFn, onImportFn, exportMenu, downloadSampleMenu, }) => {
	const classes = useStyles();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

	return (
		<Grid container spacing={1} className={classes.root} alignItems='center'>
			<Grid item xs={12} sm={12} md={5} className={classes.searchGrid}>
				<TextField
					variant='outlined'
					fullWidth
					size='small'
					placeholder={searchPlaceholder}
					defaultValue={defaultSearchValue}
					className={classes.searchField}
					onChange={(e) => onSearch && onSearch(e.target.value)}
					InputProps={{
						style: { fontSize: 12 },
						endAdornment: (
							<InputAdornment position='end'>
								<Tooltip
									title={searchPlaceholder}
									arrow
									placement='top'
								>
									<SearchIcon color='primary' style={{ cursor: 'pointer' }} />
								</Tooltip>
							</InputAdornment>
						),
					}}
				/>
			</Grid>
			<Grid item xs={12} sm={12} md={7} className={classes.actionsGrid}>
				<ul className={classes.actionsList}>
					{!permissionCheck && downloadSampleMenu && (
						<li className={classes.actionItem}>
							<ExportMenu
								exportReportFn={downloadSampleMenu?.exportReportFn}
								files={downloadSampleMenu?.files}
								title={<>{isMobile ? 'SAMPLE' : 'DOWNLOAD SAMPLE'}<KeyboardArrowDownIcon style={{ marginTop: '-1px' }} /></>}
							/>
						</li>
					)}
					{exportMenu && (
						<li className={classes.actionItem}>
							<ExportMenu
								exportReportFn={exportMenu.exportReportFn}
								files={exportMenu?.files}
								disabled={exportMenu?.disabled}
								title='EXPORT'
							/>
						</li>
					)}
					{!permissionCheck && onImportFn && (
						<li className={classes.actionItem}>
							<Button fullWidth variant='outlined' color='primary' size='small' component='label'>
								<AddIcon style={{ fontSize: '1.15rem', marginTop: '-1px' }} /> IMPORT
								<input
									className='upload-input'
									onChange={onImportFn}
									id='fileUpload'
									name='file'
									type='file'
									accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
								/>
							</Button>
						</li>
					)}
					{!permissionCheck && (
						<li className={classes.actionItem}>
							<Tooltip title={`ADD ${addLabel || ''}`} arrow placement='top'>
								<Button fullWidth variant='contained' color='primary' size='small' onClick={onAddFn}>
									<AddIcon style={{ fontSize: '1.15rem', marginTop: '-1px' }} />
									{isMobile ? 'ADD' : (addLabel || 'ADD')}
								</Button>
							</Tooltip>
						</li>
					)}
				</ul>
			</Grid>
		</Grid>
	);
};

export default CamoCTA;
